// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2364748b%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m6 9 6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
}

/* Ensure proper layout */
.App > div {
  min-height: 100vh;
}

/* Login page styles */
.login-background {
  background-size: cover;
  background-position: center;
}

/* Table hover effects */
tr.table-row-hover {
  transition: background-color 0.15s ease;
}

/* Form focus states */
input:focus,
select:focus,
textarea:focus {
  outline: none;
}

/* Button pressed state */
button:active:not(:disabled) {
  transform: scale(0.98);
}

/* Card animations */
.card-hover {
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.card-hover:hover {
  transform: translateY(-2px);
}

/* Recording indicator */
.recording-pulse {
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.15);
  }
}

/* Line clamp utility */
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Sidebar active indicator */
.nav-active {
  position: relative;
}

.nav-active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #14532D;
  border-radius: 0 2px 2px 0;
}

/* Paper document effect */
.paper-document {
  background: white;
  box-shadow: 
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  position: relative;
}

.paper-document::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  border-width: 0 16px 16px 0;
  border-style: solid;
  border-color: #f1f5f9 #f8fafc;
}

/* Loading spinner */
.loading-spinner {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #14532D;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Monospace numbers */
.mono {
  font-family: 'JetBrains Mono', monospace;
  font-variant-numeric: tabular-nums;
}

/* Status badge colors */
.badge-draft {
  background-color: #fef3c7;
  color: #92400e;
  border: 1px solid #fcd34d;
}

.badge-sent {
  background-color: #dbeafe;
  color: #1e40af;
  border: 1px solid #93c5fd;
}

.badge-accepted {
  background-color: #dcfce7;
  color: #166534;
  border: 1px solid #86efac;
}

.badge-paid {
  background-color: #d1fae5;
  color: #065f46;
  border: 1px solid #6ee7b7;
}

.badge-open {
  background-color: #ffedd5;
  color: #9a3412;
  border: 1px solid #fdba74;
}

.badge-overdue {
  background-color: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
}

/* Toast customization */
[data-sonner-toast] {
  font-family: 'Manrope', sans-serif;
}

/* Select dropdown styling */
select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  padding-right: 2.5rem;
}

/* Transition utilities */
.transition-smooth {
  transition: all 0.2s ease-out;
}

/* Focus ring for accessibility */
button:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: 2px solid #14532D;
  outline-offset: 2px;
}

/* Modal backdrop blur */
.modal-backdrop {
  backdrop-filter: blur(4px);
}

/* Responsive table */
@media (max-width: 768px) {
  .responsive-table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}

/* Print styles for PDFs */
@media print {
  .no-print {
    display: none !important;
  }
  
  body {
    background: white;
  }
  
  .paper-document {
    box-shadow: none;
    border: 1px solid #e2e8f0;
  }
}


/* Rich Text Editor Styles */
.rich-text-editor .ql-container {
  border: 1px solid hsl(var(--border));
  border-top: none;
  border-radius: 0 0 calc(var(--radius) - 2px) calc(var(--radius) - 2px);
  font-size: 14px;
  min-height: 100px;
}
.rich-text-editor .ql-toolbar {
  border: 1px solid hsl(var(--border));
  border-radius: calc(var(--radius) - 2px) calc(var(--radius) - 2px) 0 0;
  background: hsl(var(--muted));
}
.rich-text-editor .ql-editor {
  min-height: 100px;
  padding: 12px;
}
.rich-text-editor .ql-editor.ql-blank::before {
  color: hsl(var(--muted-foreground));
  font-style: normal;
}
.rich-text-editor.compact .ql-container {
  min-height: 60px;
}
.rich-text-editor.compact .ql-editor {
  min-height: 60px;
  padding: 8px;
}
.rich-text-editor.compact .ql-toolbar {
  padding: 4px 8px;
}
.rich-text-editor.compact .ql-toolbar .ql-formats {
  margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,uCAAuC;AACzC;;AAEA,sBAAsB;AACtB;;;EAGE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB;;iCAE+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,sBAAsB;AACtB;EACE,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;AACpC;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,yDAAwQ;EACxQ,4BAA4B;EAC5B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;AAC/B;;AAEA,iCAAiC;AACjC;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;;;AAGA,4BAA4B;AAC5B;EACE,oCAAoC;EACpC,gBAAgB;EAChB,sEAAsE;EACtE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,sEAAsE;EACtE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".App {\n  min-height: 100vh;\n}\n\n/* Ensure proper layout */\n.App > div {\n  min-height: 100vh;\n}\n\n/* Login page styles */\n.login-background {\n  background-size: cover;\n  background-position: center;\n}\n\n/* Table hover effects */\ntr.table-row-hover {\n  transition: background-color 0.15s ease;\n}\n\n/* Form focus states */\ninput:focus,\nselect:focus,\ntextarea:focus {\n  outline: none;\n}\n\n/* Button pressed state */\nbutton:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n/* Card animations */\n.card-hover {\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.card-hover:hover {\n  transform: translateY(-2px);\n}\n\n/* Recording indicator */\n.recording-pulse {\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.6;\n    transform: scale(1.15);\n  }\n}\n\n/* Line clamp utility */\n.line-clamp-2 {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Sidebar active indicator */\n.nav-active {\n  position: relative;\n}\n\n.nav-active::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: #14532D;\n  border-radius: 0 2px 2px 0;\n}\n\n/* Paper document effect */\n.paper-document {\n  background: white;\n  box-shadow: \n    0 1px 3px rgba(0, 0, 0, 0.12),\n    0 1px 2px rgba(0, 0, 0, 0.24);\n  position: relative;\n}\n\n.paper-document::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  border-width: 0 16px 16px 0;\n  border-style: solid;\n  border-color: #f1f5f9 #f8fafc;\n}\n\n/* Loading spinner */\n.loading-spinner {\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #14532D;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Monospace numbers */\n.mono {\n  font-family: 'JetBrains Mono', monospace;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Status badge colors */\n.badge-draft {\n  background-color: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fcd34d;\n}\n\n.badge-sent {\n  background-color: #dbeafe;\n  color: #1e40af;\n  border: 1px solid #93c5fd;\n}\n\n.badge-accepted {\n  background-color: #dcfce7;\n  color: #166534;\n  border: 1px solid #86efac;\n}\n\n.badge-paid {\n  background-color: #d1fae5;\n  color: #065f46;\n  border: 1px solid #6ee7b7;\n}\n\n.badge-open {\n  background-color: #ffedd5;\n  color: #9a3412;\n  border: 1px solid #fdba74;\n}\n\n.badge-overdue {\n  background-color: #fee2e2;\n  color: #991b1b;\n  border: 1px solid #fca5a5;\n}\n\n/* Toast customization */\n[data-sonner-toast] {\n  font-family: 'Manrope', sans-serif;\n}\n\n/* Select dropdown styling */\nselect {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  padding-right: 2.5rem;\n}\n\n/* Transition utilities */\n.transition-smooth {\n  transition: all 0.2s ease-out;\n}\n\n/* Focus ring for accessibility */\nbutton:focus-visible,\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible {\n  outline: 2px solid #14532D;\n  outline-offset: 2px;\n}\n\n/* Modal backdrop blur */\n.modal-backdrop {\n  backdrop-filter: blur(4px);\n}\n\n/* Responsive table */\n@media (max-width: 768px) {\n  .responsive-table {\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n}\n\n/* Print styles for PDFs */\n@media print {\n  .no-print {\n    display: none !important;\n  }\n  \n  body {\n    background: white;\n  }\n  \n  .paper-document {\n    box-shadow: none;\n    border: 1px solid #e2e8f0;\n  }\n}\n\n\n/* Rich Text Editor Styles */\n.rich-text-editor .ql-container {\n  border: 1px solid hsl(var(--border));\n  border-top: none;\n  border-radius: 0 0 calc(var(--radius) - 2px) calc(var(--radius) - 2px);\n  font-size: 14px;\n  min-height: 100px;\n}\n.rich-text-editor .ql-toolbar {\n  border: 1px solid hsl(var(--border));\n  border-radius: calc(var(--radius) - 2px) calc(var(--radius) - 2px) 0 0;\n  background: hsl(var(--muted));\n}\n.rich-text-editor .ql-editor {\n  min-height: 100px;\n  padding: 12px;\n}\n.rich-text-editor .ql-editor.ql-blank::before {\n  color: hsl(var(--muted-foreground));\n  font-style: normal;\n}\n.rich-text-editor.compact .ql-container {\n  min-height: 60px;\n}\n.rich-text-editor.compact .ql-editor {\n  min-height: 60px;\n  padding: 8px;\n}\n.rich-text-editor.compact .ql-toolbar {\n  padding: 4px 8px;\n}\n.rich-text-editor.compact .ql-toolbar .ql-formats {\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
